import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, nextTick } from 'vue'
import { useRouter, useNuxtApp } from '#app'
import {
  Module,
  useCreateVentureAccountAndInviteUserMutation,
} from '~/types/types'
import {
  portfolioVentureNameRules,
  portfolioVentureWebsiteRules,
  portfolioVentureInviteEmailRules,
} from '~/functions/portfolioVentureFormRules'


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioSetupCompanyForm',
  props: {
    modules: null
  },
  emits: ["company-created", "done"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'company-created'): void
  (e: 'done'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modules: Module[]
};





const router = useRouter()
const { $i18n } = useNuxtApp()

const form = ref()
const ventureName = ref('')
const website = ref('')
const inviteEmail = ref('')
const sendInvitationNow = ref(false)
const inviteEmailError = ref('')
const createSuccess = ref(false)
const createdCompanyName = ref('')
const createdVentureId = ref<string | null>(null)
const createdWithInvite = ref(false)

const nameRules = computed(() =>
  portfolioVentureNameRules((key) => $i18n.t(key)),
)
const websiteRules = computed(() =>
  portfolioVentureWebsiteRules((key) => $i18n.t(key)),
)
const inviteEmailRules = computed(() =>
  portfolioVentureInviteEmailRules((key) => $i18n.t(key)),
)

const hasCompanyInfoModule = computed(() =>
  props.modules.includes(Module.CompanyInfo),
)

const {
  mutate: createVenture,
  loading,
  onDone: onCreateDone,
} = useCreateVentureAccountAndInviteUserMutation()

onCreateDone(({ data }) => {
  const result = data?.createVentureAccountAndInviteUser
  if (result?.success) {
    createdCompanyName.value = ventureName.value
    createdVentureId.value = result.ventureId ?? null
    createdWithInvite.value =
      sendInvitationNow.value && Boolean(inviteEmail.value.trim())
    createSuccess.value = true
    emit('company-created')
    return
  }
  if (result?.message) {
    inviteEmailError.value = result.message
  }
})

function resetForm() {
  ventureName.value = ''
  website.value = ''
  inviteEmail.value = ''
  sendInvitationNow.value = false
  inviteEmailError.value = ''
  createSuccess.value = false
  createdCompanyName.value = ''
  createdVentureId.value = null
  createdWithInvite.value = false
  nextTick(() => {
    form.value?.reset?.()
    form.value?.resetValidation?.()
  })
}

function onSubmit() {
  if (!form.value?.validate?.()) {
    return
  }
  inviteEmailError.value = ''
  const email =
    sendInvitationNow.value && inviteEmail.value.trim()
      ? inviteEmail.value.trim()
      : undefined
  createVenture({
    ventureName: ventureName.value,
    website: website.value || undefined,
    modules: props.modules.length ? props.modules : undefined,
    email,
  })
}

function goToConfigure() {
  if (createdVentureId.value) {
    router.push(`/${createdVentureId.value}/company`)
  }
}

function dismissSuccess() {
  resetForm()
  emit('done')
}

return { __sfc: true,props, emit, router, $i18n, form, ventureName, website, inviteEmail, sendInvitationNow, inviteEmailError, createSuccess, createdCompanyName, createdVentureId, createdWithInvite, nameRules, websiteRules, inviteEmailRules, hasCompanyInfoModule, createVenture, loading, onCreateDone, resetForm, onSubmit, goToConfigure, dismissSuccess }
}

})